export default __webpack_public_path__ + "static/media/Moderat-Extended-Medium.47578d4b.ttf";